import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const reviews = [{
    text: 'Finally found a landscaping company in San Diego that actually shows up and does the job right. My yard has never looked better. Highly recommend YEI Mateo!',
    author: 'Maria G.',
    location: 'El Cajon, CA'
  }, {
    text: 'They installed pavers in my backyard and it turned out incredible. Fair price, clean work, no surprises. These guys are the real deal.',
    author: 'James R.',
    location: 'Santee, CA'
  }, {
    text: "Weekly maintenance, tree trimming, and a full cleanup — all done by the same crew. Reliable, professional, and great communication. Won't use anyone else.",
    author: 'Sandra M.',
    location: 'Chula Vista, CA'
  }];
  return <section className="py-20 bg-white" data-id="element-238">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <div className="text-center mb-16" data-id="element-240">
          <span className="text-primary font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-241">
            WHAT CUSTOMERS ARE SAYING
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-darkCharcoal mb-6" data-id="element-242">
            Real Homeowners. Real Results.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-243">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-100 flex flex-col h-full" data-id="element-244">
              <div className="flex gap-1 mb-6" data-id="element-245">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-yellow-400 text-yellow-400" data-id="element-246" />)}
              </div>
              <p className="text-gray-700 leading-relaxed mb-8 flex-grow text-lg italic" data-id="element-247">
                "{review.text}"
              </p>
              <div className="mt-auto border-t border-gray-200 pt-4" data-id="element-248">
                <p className="font-bold text-darkCharcoal" data-id="element-249">{review.author}</p>
                <p className="text-sm text-gray-500" data-id="element-250">— {review.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}